import { SVGProps } from 'react'

export const ToggleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5505 7H4C2.61929 7 1.5 5.88071 1.5 4.5C1.5 3.11929 2.61929 2 4 2H13.5505M7.44949 18H17C18.3807 18 19.5 16.8807 19.5 15.5C19.5 14.1193 18.3807 13 17 13H7.44949M1.5 15.5C1.5 17.433 3.067 19 5 19C6.933 19 8.5 17.433 8.5 15.5C8.5 13.567 6.933 12 5 12C3.067 12 1.5 13.567 1.5 15.5ZM19.5 4.5C19.5 6.433 17.933 8 16 8C14.067 8 12.5 6.433 12.5 4.5C12.5 2.567 14.067 1 16 1C17.933 1 19.5 2.567 19.5 4.5Z"
      stroke="#667085"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
